import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 },
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [earnPointsMethodData, setEarnPointsMethodData] = useState<any>();
    const [membershipRechargeLockRulesData, setMembershipRechargeLockRulesData] = useState<any>();
    const [earnDisabled, setEarnDisabled] = useState<boolean>(false);
    const [earnSelectOneDisabled, setEarnSelectOneDisabled] = useState<boolean>(false);
    const [earnSelectTwoDisabled, setEarnSelectTwoDisabled] = useState<boolean>(false);
    const [redeemDisabled, setRedeemDisabled] = useState<boolean>(false);
    const [permanentUseDisabled, setPermanentUseDisabled] = useState<boolean>(false);

    /** 后端数据defaultService */
    let defaultService: any = '';
    useEffect(() => {
        if (ref.current) {
            defaultService = ref.current.defaultService;
            ref.current.row.then((res: any) => {
                if (res?.success === true) {
                    setEarnDisabled(!res.data.isEarn);
                    handeleEarnSelectDisabled(!res.data.isEarn);
                    setRedeemDisabled(!res.data.isRedeem);
                    setPermanentUseDisabled(res.data.isPermanentUse);
                }
            })
        }
        fetchApi.GET(defaultService,
            {
                apiId: 'generalData',
                apiVariable: 'calcMode',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { calcMode } = res.data;
                    setEarnPointsMethodData(calcMode);;
                }
            })
        fetchApi.GET(defaultService,
            {
                apiId: 'membershipRechargeLockRules',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMembershipRechargeLockRulesData(res.data);;
                }
            })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const handeleEarnSelectDisabled = (e?: boolean) => {
        if (e === true) {
            setEarnSelectOneDisabled(true);
            setEarnSelectTwoDisabled(true);
        } else {
            const earnPointsMethodId = form.getFieldValue('earnPointsMethodId');
            switch (earnPointsMethodId) {
                case 1:
                    setEarnSelectOneDisabled(false);
                    setEarnSelectTwoDisabled(true);
                    break;
                case 2:
                    setEarnSelectOneDisabled(true);
                    setEarnSelectTwoDisabled(false);
                    break;
                default:
                    setEarnSelectOneDisabled(true);
                    setEarnSelectTwoDisabled(true);
                    break;
            }
        }
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'membershipPointsPlans',
        serviceId: 'business',
        dateColumnName: ['startDate', 'endDate']
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '会员积分方案'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1000}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            // handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={4}>
                            <Form.Item
                                label="ID"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={9}>
                            <Form.Item
                                label="方案"
                                name="planName"
                                rules={[{ required: true, message: '方案名称!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="永久"
                                name="isPermanentUse"
                                tooltip='方案永久使用'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch
                                    onChange={(e) => {
                                        setPermanentUseDisabled(e);
                                    }}
                                    checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="已用"
                                name="usedCopies"
                                tooltip='方案已用份数'>
                                <InputNumber
                                    disabled={data.type === 'NEW' ? true : false}
                                    style={{ width: 90 }} />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="总数"
                                name="totalCopies"
                                tooltip='方案的总份数' >
                                <InputNumber
                                    disabled={permanentUseDisabled}
                                    style={{ width: 90 }} />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="获取"
                                name="isEarn"
                                tooltip='当前方案是否可以获取积分'
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    onChange={(e) => {
                                        setEarnDisabled(!e);
                                        handeleEarnSelectDisabled(!e);
                                    }}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="获取方法"
                                name="earnPointsMethodId">
                                <Select
                                    showSearch
                                    placeholder="获取积份的方法"
                                    optionFilterProp="children"
                                    disabled={earnDisabled}
                                    onChange={() => {
                                        handeleEarnSelectDisabled();
                                    }}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(earnPointsMethodData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="积分"
                                name="earnPoints"
                                tooltip='获取积份方法为【按数值】时所获得的积分'>
                                <InputNumber
                                    disabled={earnSelectOneDisabled}
                                    style={{ width: 130 }} />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="获取比率"
                                name="earnPointsCalculateRatio"
                                tooltip='获取积份方法为【按比例】时所获得积分的计算比率，如2元获得1积分填2，1元获得1积分填1，1元获得2积分填0.5'>
                                <InputNumber
                                    disabled={earnSelectTwoDisabled}
                                    style={{ width: 105 }} />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="延长"
                                name="extendPointsExpiry"
                                tooltip='延长积分有效期(天)'>
                                <InputNumber
                                    disabled={earnDisabled}
                                    style={{
                                        width: 100
                                    }} />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="兑换"
                                name="isRedeem"
                                tooltip='当前方案是否可以兑换积分'
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch
                                    onChange={(e) => { setRedeemDisabled(!e); }}
                                    checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="兑换比率"
                                name="redeemPointsCalculateRatio"
                                tooltip='兑换积分的计算比率，如30积分兑换1元填30'>
                                <InputNumber
                                    disabled={redeemDisabled}
                                    style={{ width: 65 }} />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="下限"
                                name="minimumPointsRedemptionThreshold"
                                tooltip='积分兑换时所需的最低积分'>
                                <InputNumber
                                    disabled={redeemDisabled}
                                    style={{ width: 50 }} />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="上限"
                                name="maximumPointsRedemptionLimit"
                                tooltip='积分兑换时所需的最高上限'>
                                <InputNumber
                                    disabled={redeemDisabled}
                                    style={{ width: 90 }} />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="锁定规则"
                                name="membershipRechargeLockRulesId">
                                <Select
                                    showSearch
                                    placeholder="锁定规则"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(membershipRechargeLockRulesData,
                                        {
                                            itemName: 'ruleName',
                                            includeNull: true
                                        })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="新客"
                                name="isExclusiveToNewCustomers"
                                tooltip='新客专用'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="起始日期"
                                name="startDate"
                                tooltip='充值方案的起始日期'>
                                <DatePicker
                                    disabled={permanentUseDisabled}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="结束日期"
                                name="endDate"
                                tooltip='充值方案的结束日期'>
                                <DatePicker
                                    disabled={permanentUseDisabled}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="排序"
                                name="sorting"
                                tooltip='排序，数字小排前面'>
                                <InputNumber style={{ width: 75 }} />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="默认"
                                name="isDefault"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;